<template>
    <app-container class="!max-w-screen-md">
        <div class="flex items-center my-12">
            <div class="flex-1">
                <img class="mx-auto h-auto w-auto max-h-24 max-w-[24rem]" :src="`/images/logos/tyre-sites/${website.name}.png`"/>
            </div>
        </div>

        <app-card size="big">
            <slot></slot>
        </app-card>

        <app-powered-by class="mt-16 mb-8"></app-powered-by>
    </app-container>
</template>
<script>
import AppContainer from "@/Layouts/AppContainer.vue";
import AppCard from '@/Components/AppCard.vue';
import AppPoweredBy from '@/Components/AppPoweredBy.vue';
import AppLogo from '@/Components/AppLogo.vue';

export default {
    components: {
        AppContainer, AppCard, AppPoweredBy, AppLogo
    },
    props: {
        website: Object
    },
};
</script>


<style lang="scss" scoped>

</style>
